import { httpClient } from "../http-client";

export type MeStatus = "active" | "inactive";

export interface MeUser {
  id: number;
  crm_id: number;
  email: string;
  first_name: string;
  last_name: string;
  status: MeStatus;
  created_at: string;
  updated_at: string;
}

export interface MeCrm {
  id: number;
  name: string;
  status: MeStatus;
  created_at: string;
  updated_at: string;
}

export interface Me {
  user: MeUser;
  crm: MeCrm;
}

// pf-developer-network is mounted behind the platform gateway under the /pfdn
// service prefix (stripped by the ALB); GET /v1/me introspects the bearer token
// and returns the caller's user plus its CRM.
const ME_PATH = "/pfdn/v1/me";

export async function fetchMe(): Promise<Me> {
  const { data } = await httpClient.get<Me>(ME_PATH);
  return data;
}
